import { Schema } from 'effect';
import { IPositionsArray, PositionsArray } from './positions';

export const positions: IPositionsArray = Schema.decodeSync(PositionsArray)([
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: '3dea8c65-0ed2-442d-a8cc-4290418d9887',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 3,
		price: 9_965.94,
		quantity: 1,
		status: 'succeeded',
		totalPrice: 9965.94,
		type: 'model',
		width: 1400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: 'd824032d-87c6-4dde-8cab-30fc6405d7a5',
		key: 'K12316401M02',
		position: 3.1,
		price: 110.02,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 220.04,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: 'c16060f0-a986-41d2-a29e-ab6001b65f18',
		key: 'TXT_BORNHOLM',
		position: 3.2,
		price: 7438.76,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 7438.76,
		type: 'text',
	},
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: '146063ef-c789-4aee-86ab-10cf62ef6a6e',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 4,
		price: 4422.38,
		quantity: 1,
		status: 'failed',
		totalPrice: 4422.38,
		type: 'model',
		width: 1_400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: 'f35cbe68-e287-45a5-b98b-0e26e564f9a6',
		key: 'K12316401M02',
		position: 4.1,
		price: 123.65,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 247.3,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: '35ff79df-6ad8-4ac9-9e90-5237f4c39603',
		key: 'TXT_BORNHOLM',
		position: 4.2,
		price: 13756.98,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 13756.98,
		type: 'text',
	},
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: '17e74f23-0b5d-4fff-ab54-c87e1c50a337',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 5,
		price: 4823.85,
		quantity: 1,
		status: 'succeeded',
		totalPrice: 4823.85,
		type: 'model',
		width: 1_400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: '1d955d69-64c7-4b0d-9609-88b08fce2594',
		key: 'K12316401M02',
		position: 5.1,
		price: 186.09,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 372.18,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: 'd7438fd2-7dfd-445a-a7f9-c1586ce79042',
		key: 'TXT_BORNHOLM',
		position: 5.2,
		price: 5698.42,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 5698.42,
		type: 'text',
	},
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: '1a769860-c817-4f5f-b448-0ec8ae44026c',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 6,
		price: 9812.67,
		quantity: 1,
		status: 'succeeded',
		totalPrice: 9812.67,
		type: 'model',
		width: 1_400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: 'e9631c04-51e4-4220-84f6-477203648e42',
		key: 'K12316401M02',
		position: 6.1,
		price: 234.07,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 468.14,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: '436c6697-2585-42df-83da-3eea66331b39',
		key: 'TXT_BORNHOLM',
		position: 6.2,
		price: 6243.87,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 6243.87,
		type: 'text',
	},
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: 'dbbef25c-056b-4932-bb5d-64d0e9ecab48',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 7,
		price: 14987.87,
		quantity: 1,
		status: 'succeeded',
		totalPrice: 14987.87,
		type: 'model',
		width: 1_400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: '562b64cf-0e2e-4c7e-809f-1a0341e93833',
		key: 'K12316401M02',
		position: 7.1,
		price: 456.53,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 913.06,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: 'c6ce0789-897a-4984-bc86-7afd7ac9e5c2',
		key: 'TXT_BORNHOLM',
		position: 7.2,
		price: 15876.12,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 15876.12,
		type: 'text',
	},
	{
		description: 'EFH 0:0 1400/13',
		height: 1_280,
		id: '9a1dfe89-8292-4ea4-9dc4-94c87919ac6f',
		key: '71100085479',
		litra: 'sovrum',
		note: 'Noter omkring model her.',
		position: 10,
		price: 11970.8,
		quantity: 1,
		status: 'succeeded',
		totalPrice: 11970.8,
		type: 'model',
		width: 1_400,
	},
	{
		description: 'Plissé (Utåt 61) Monterad Båge Vrid',
		id: '48e269f3-194b-4f86-8d36-f1a1d59e17f2',
		key: 'K12316401M02',
		position: 10.1,
		price: 433.32,
		quantity: 2,
		status: 'succeeded',
		totalPrice: 866.64,
		type: 'stock',
	},
	{
		description: 'Transport afgifter',
		id: '062b3821-ecc8-4965-8fcf-474e14b6e312',
		key: 'TXT_BORNHOLM',
		position: 10.2,
		price: 16980.64,
		quantity: 1,
		status: 'succeeded',
		text: 'Bemærk at fragt til og fra Bornholm kræver Øresundsbro afgift, samt færge.',
		totalPrice: 16980.64,
		type: 'text',
	},
]);
